<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      :clipped="$vuetify.breakpoint.mdAndUp"
      color="#222A30"
      width="220"
      dark
      app
    >
      <v-list dense nav>
        <template v-for="item in menus">
          <v-row
            v-if="item.heading"
            :key="item.heading"
            align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col
              cols="6"
              class="text-center">
              <a
                href="#!"
                class="body-2 black--text"
              >EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.title"
            v-model="item.model"
            :append-outer-icon="item.model ? item.icon : item['icon-alt']"
            :prepend-icon="item.main_icon">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
              >
              <v-list-item-action v-if="child.icon" @click.prevent="child.action">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content @click.prevent="child.action">
                <v-list-item-title>
                  {{ child.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            :key="item.title"
            link>
            <v-list-item-action @click.prevent="item.action">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content @click.prevent="item.action">
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
    </v-list>
    
    <v-toolbar style="position:absolute; bottom: 0px; right:0px; left: 0px;" dense>
        <v-toolbar-items>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="mini = !mini" v-on="on">
                <v-icon>view_headline</v-icon>
              </v-btn>
            </template>
            <span>Collapse Menu</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="profile" v-on="on" class="ml-4">
                <v-icon>fa-user</v-icon>
              </v-btn>
            </template>
            <span>Profile</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="quickStart" v-on="on">
                <v-icon>fa-rocket</v-icon>
              </v-btn>
            </template>
            <span>Quick Start</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="logout" v-on="on">
                <v-icon>fa-sign-out-alt</v-icon>
              </v-btn>
            </template>
            <span>Logout</span>
          </v-tooltip>
        </v-toolbar-items>
      </v-toolbar>
  </v-navigation-drawer>
  <v-app-bar app
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    color="#0f4e74"
    height="50"
    dark
    class="pl-4"
    flat>
        <img src="../assets/logo_new.png" width="170px" @click.stop="home">
        <div v-if="$vuetify.breakpoint.smAndUp" style="margin-left: 10px;" @click="showTimeChooser">{{ ' '}}  Current Time: {{ cTime }} {{ (dst==1)?getTimezoneAbbr():'MST' }}</div>
        <v-spacer></v-spacer>

        <v-tooltip top v-if="$vuetify.breakpoint.smAndDown">
            <template v-slot:activator="{ on }">
              <v-btn icon @click="toggleNavigation" v-on="on">
                <v-icon>view_headline</v-icon>
              </v-btn>
            </template>
            <span>Collapse Menu</span>
        </v-tooltip>
        <v-btn icon @click="profile">
          <v-icon>person</v-icon>
        </v-btn>
    </v-app-bar>
    <v-dialog v-model="dialog" max-width="350">
      <v-card tile>
        <v-card-title>Setting / Timezone</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-for="(timezon, index) in timezons" 
                :key="index"
                class="mt-0"
                v-model="timezon.checked"
                dense
                :label="timezon.dname"
                @click="timezonChange(timezon.name, timezon.dst)"
                ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" tile @click.prevent="dialog = !dialog">Cancel</v-btn>
          <v-btn color="primary" tile @click="saveUserTimezone">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import moment from 'moment'
import mtz from 'moment-timezone'
import axios from './../../../axios'
import timezon from '../../../timezons'
export default {
    data(){
        return {
          dst:1,
          dialog: false,
          drawer: true,
          mini: false,
          selectedTimezone: this.$store.getters.getTimezone,
          cTime: localStorage.getItem("timezone") ? moment(moment().tz(this.$store.getters.getTimezone).format('MM/DD/YYYY HH:mm'), 'MM/DD/YYYY HH:mm').utc().format('MM-DD-YYYY LT') : moment().tz(this.$store.getters.getTimezone).format('MM-DD-YYYY LT'),
          timezons: timezon,
          isAdmin:false,
          timezoneChanger: null,
          menus:[
              {title: 'Radios', icon: 'radio', action: this.radios},
              {title: 'Schedules', icon: 'today', action: ()=>{this.$router.push('/dashboard/schedules').catch(e=>{})}},
              // {title: 'Schedules', icon: 'today', action: ()=>{this.$router.push('/dashboard/schedule').catch(e=>{})}},
              {title: 'Messages', icon: 'fa-microphone', action: ()=>{this.$router.push('/dashboard/messages').catch(e=>{})}},
              {title: 'Message Playlist', icon: 'queue_music', action: ()=>(this.$router.push('/dashboard/playlist').catch(e=>{}))},
              {title: 'Timezone', icon: 'fa-clock', action: this.timezonselector}
          ]
        }
    },
    methods:{
      showTimeChooser(){
        this.timezons.forEach(timezone=>{
            if(timezone.name == localStorage.getItem('timezone') && timezone.dst == this.dst){
              timezone.checked = 1
            }else{
              timezone.checked = 0
            }
          })
        
        this.dialog = true
      },
      timezonChange(timezon, dst){
          this.timezons.forEach(timezone=>{
            if(timezone.name == timezon && timezone.dst == dst){
              timezone.checked = 1
              this.dst = dst
            }else{
              timezone.checked = 0
            }
          })

          this.selectedTimezone = timezon
      },
      currentTime(){
        let timezonelist = moment.tz.names()
      },
      getTimezoneAbbr(){
        return mtz().tz(this.$store.getters.getTimezone).format('zz')
      },
      toggleNavigation(){
        this.drawer = !this.drawer
      },
      schedule(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/dashboard/schedule').catch(error=>{})
      },
      schedules(){
         localStorage.setItem('scheduleId', 0)
         this.$router.push('/dashboard/schedules').catch(error=>{})
      },
      scheduleManage(){
        this.$router.push('/dashboard/schedule-manage').catch(error=>{})
      },
      scheduleAdd(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/dashboard/schedule-add').catch(error=>{})
      },
      home(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/dashboard/radios').catch(err=>{})
      },
      logout(){
        localStorage.setItem('scheduleId', 0)
        this.$store.dispatch('logout')
        this.$router.push('/')
      },
      profile(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/dashboard/profile').catch(err=>{})
      },
      radios(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/dashboard/radios').catch(error=>{})
      },
      quickStart(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/dashboard/quick-start').catch(err=>{})
      },
      timezonselector(){
        this.timezons.forEach(timezone=>{
            if(timezone.name == localStorage.getItem('timezone') && timezone.dst == localStorage.getItem('dst')){
              timezone.checked = 1
            }else{
              timezone.checked = 0
            }
          })
        this.dialog = true
      },
      saveUserTimezone(){
        let user = {
          timezone: this.selectedTimezone,
          dst: this.dst
        }
        axios.post('change-timezone?token='+this.$store.getters.getToken, user)
          .then(response=>{
            this.$store.dispatch('setAlert', 'Timezone has been changed.')
            localStorage.setItem('timezone', this.selectedTimezone)
            localStorage.setItem('dst', this.dst)
            this.$store.dispatch('setUserTimezone', this.selectedTimezone)
            this.dialog = false
            
            if(this.dst){
              this.cTime = moment().tz(this.$store.getters.getTimezone).format('MM-DD-YYYY LT')
            }else{
              // this.cTime = moment(moment().tz(this.$store.getters.getTimezone).format('MM/DD/YYYY HH:mm'), 'MM/DD/YYYY HH:mm').utc().format('MM-DD-YYYY LT')
              // US/Pacific
              this.cTime = moment().tz('US/Pacific').format('MM-DD-YYYY LT')
            }
            
          })
          .catch(error=>{
            this.$store.dispatch('setErrorAlert', 'There is an error.')
          })
        
      }
    },
    created(){
        if(parseInt(this.$store.getters.getIsAdmin) == 1){
          this.isAdmin = true
        }else{
          this.isAdmin = false
        }

      this.timezons.forEach(timezone=>{
            if(timezone.name == this.$store.getters.getTimezone){
              timezone.checked = 1
            }else{
              timezone.checked = 0
            }
        })
      this.currentTime()

      this.dst = localStorage.getItem('dst')

      if(this.dst){
        this.cTime = moment().tz(this.$store.getters.getTimezone).format('MM-DD-YYYY LT')
      }else{
         // this.cTime = moment(moment().tz(this.$store.getters.getTimezone).format('MM/DD/YYYY HH:mm'), 'MM/DD/YYYY HH:mm').utc().format('MM-DD-YYYY LT')
              // US/Pacific
              this.cTime = moment().tz('US/Pacific').format('MM-DD-YYYY LT')
      }

      if(this.timezoneChanger){
          clearInterval(this.timezoneChanger)
      }

      this.timezoneChanger = setInterval(()=>{
          this.cTime = moment().tz(this.$store.getters.getTimezone).format('MM-DD-YYYY LT')
      }, 10000)


    },
    beforeDestroy(){
        if(this.timezoneChanger){
            clearInterval(this.timezoneChanger)
        }
    }
}
</script>

<style scoped>
.v-application .primary--text {
    color: #e2e8ef !important;
    caret-color: #ecf0f3 !important;
}
</style>